<template>
  <h1 class="title">
    <slot></slot>
  </h1>
</template>


<script>
export default {
  name: "PageTitle"
};
</script>

<style scoped>
.title {
  font-size: 1.2em;
  font-weight: 700;
  color: #001038;
  border-bottom: 1px solid #00164d73;
  line-height: 1.1em;
  padding-bottom: 5px;
  font-style: "Poppins";
}
</style>

